// import packages
import gql from "graphql-tag"

export const IMPORT_FILE = gql`
  mutation ImportFile($file: Upload!, $type: FileType!) {
    importFile(file: $file, type: $type)
  }
`
